// utils/platformSpecs.js

// Base defaults reused when a platform doesn't override
export const DEFAULT_REQUIRED = ['Message', 'SenderScreenName', 'CreatedTime'];

// Per-platform specs (add/adjust as needed)
export const PLATFORM_SPECS = {
  x: {
    label: 'X (Twitter)',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'Message Type',
      'OriginalAuthor',
      'SenderProfileImgUrl',
      'Sender Followers Count',
      'Tweet Generator',
    ],
  },

  reddit: {
    label: 'Reddit',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'Title',
      'Message Type',
      'OriginalAuthor',
      'SenderProfileImgUrl',
      'Sender Followers Count',
      'Tweet Generator',
    ],
  },

  steam: {
    label: 'Steam',
    requiredCanon: [...DEFAULT_REQUIRED, 'OriginalPostId'],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'SenderProfileImgUrl',
      'SenderProfilePrivacyStatus',
      'author_playtime_forever',
      'Country',
    ],
  },
  
  'youtube-vid-text': {
    label: 'YouTube Videos Texts',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'SenderProfileImgUrl',
      'SenderProfileCreationDate',
      'OriginalPostDescription',
      'Sender Followers Count',
    ],
  },

  'youtube-comments': {
    label: 'YouTube Comments',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'Message Type',
      'SenderProfileCreationDate',
      'Sender Followers Count',
      'OriginalPostId',
      'TotalPosts',
      'OriginalAuthor',
      'SenderPorfileBannerUrl',
      
    ],
  },

  'disqus':{
    label: 'Disqus',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId',
      'Message Type',
      'SenderProfileCreationDate',
      'Sender Followers Count',
      'OriginalPostId',
      'SenderProfileImgUrl',
      'SenderReputation',

    ],
  },

  'bluesky':{
    label: 'Bluesky',
    requiredCanon: [...DEFAULT_REQUIRED],
    optionalCanon: [
      'Permalink',
      'SenderUserId', 
      'Message Type',
      'PostsCount',
      'SenderProfileImgUrl',
      'SenderFollowersCount',
      'SenderProfileDesc',
      'AccountCreated'

    ],
  },

  facebook: { label: 'Facebook', requiredCanon: [...DEFAULT_REQUIRED], optionalCanon: ['Permalink', 'SenderUserId', 'SenderProfileImgUrl'] },
  // instagram:{ label: 'Instagram', requiredCanon: [...DEFAULT_REQUIRED], optionalCanon: ['Permalink'] },
  // tiktok:   { label: 'TikTok',    requiredCanon: [...DEFAULT_REQUIRED], optionalCanon: ['Permalink'] },
  // youtube:  { label: 'YouTube',   requiredCanon: [...DEFAULT_REQUIRED], optionalCanon: ['Permalink'] },
};

// Convenience (named) exports — return arrays, never mutate originals
export function getRequiredFor(platform) {
  const spec = PLATFORM_SPECS[platform];
  return Array.isArray(spec?.requiredCanon) ? [...spec.requiredCanon] : [...DEFAULT_REQUIRED];
}

export function getOptionalFor(platform) {
  const spec = PLATFORM_SPECS[platform];
  return Array.isArray(spec?.optionalCanon) ? [...spec.optionalCanon] : [];
}
